document.addEventListener("DOMContentLoaded",()=>{
const body=document.body;
const intro=document.querySelector("#mgIntro");
const closeIntro=()=>{if(!intro)return;intro.classList.add("mg-intro-out");setTimeout(()=>intro.remove(),600)};
document.querySelector("[data-close-intro]")?.addEventListener("click",closeIntro);
if(intro)setTimeout(closeIntro,4000);
const overlay=document.querySelector("[data-search-overlay]");
const openSearch=()=>{overlay?.classList.add("open");body.classList.add("mg-lock");setTimeout(()=>overlay?.querySelector("input")?.focus(),80)};
const closeSearch=()=>{overlay?.classList.remove("open");body.classList.remove("mg-lock")};
document.querySelector("[data-search-open]")?.addEventListener("click",openSearch);
document.querySelector("[data-search-close]")?.addEventListener("click",closeSearch);
const drawer=document.querySelector("[data-mobile-drawer]");
const openDrawer=()=>{drawer?.classList.add("open");body.classList.add("mg-lock")};
const closeDrawer=()=>{drawer?.classList.remove("open");body.classList.remove("mg-lock")};
document.querySelector("[data-menu-toggle]")?.addEventListener("click",openDrawer);
document.querySelector("[data-menu-close]")?.addEventListener("click",closeDrawer);
document.addEventListener("keydown",e=>{if(e.key==="Escape"){closeSearch();closeDrawer()}});
document.querySelectorAll("[data-qty]").forEach(box=>{
 const input=box.querySelector("input");
 box.querySelector("[data-minus]")?.addEventListener("click",()=>input.value=Math.max(1,(parseInt(input.value)||1)-1));
 box.querySelector("[data-plus]")?.addEventListener("click",()=>input.value=(parseInt(input.value)||1)+1);
});
});